import { DefaultTemplate, COR, CORES_SIM_NAO, CORES_PRIORIDADE } from './types';

// ============================================================
// OBRAS — GESTÃO DE CONTRATO, PROJETO, ATIVOS E CONFORMIDADE
//
// Complementa ./obras.ts (que cobre o canteiro: execução, empreiteiro,
// material, segurança e garantia). Aqui mora o que uma construtora de porte
// precisa além do campo: licitação, faturamento do contrato, aditivo/pleito,
// coordenação de projetos, frota, FVS da qualidade e resíduos.
// ============================================================

const licitacaoObra: DefaultTemplate = {
  id: 'tpl_licitacao_obra',
  name: 'Licitações e Propostas de Obra',
  descricao: 'Da captação do edital ao contrato assinado: análise de participação, composição de custo com BDI, aprovação da diretoria, entrega da proposta e resultado. Para construtora que disputa concorrência pública e privada.',
  categoria: 'obras',
  icone: '📊',
  etiquetas: [
    { nome: 'Pública', cor: COR.azul },
    { nome: 'Privada', cor: COR.roxo },
    { nome: 'Consórcio', cor: COR.ciano },
    { nome: 'Prazo Curto', cor: COR.vermelho },
  ],
  etapas: [
    {
      id: 'lc_e1', nome: 'Oportunidade Captada',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['lc_c1', 'lc_c3', 'lc_c6'],
      permiteMoverPara: ['lc_e2'],
      campos: [
        { id: 'lc_c1', nome: 'Objeto da Licitação', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'lc_c2', nome: 'Contratante / Órgão', tipo: 'texto', obrigatorio: true },
        { id: 'lc_c3', nome: 'Modalidade', tipo: 'lista', obrigatorio: true, opcoes: ['Concorrência pública', 'Pregão eletrônico', 'Tomada de preços', 'RDC', 'Convite privado', 'Cotação direta', 'Dispensa'], coresOpcoes: { 'Concorrência pública': COR.azul, 'Convite privado': COR.roxo } },
        { id: 'lc_c4', nome: 'Nº do Edital / Processo', tipo: 'texto', obrigatorio: false },
        { id: 'lc_c5', nome: 'Edital e Anexos', tipo: 'anexo', obrigatorio: false },
        { id: 'lc_c6', nome: 'Data de Entrega da Proposta', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'lc_c7', nome: 'Valor Estimado pelo Contratante', tipo: 'valor', obrigatorio: false },
        { id: 'lc_c8', nome: 'Local da Obra', tipo: 'texto', obrigatorio: false },
        { id: 'lc_c9', nome: 'Origem da Oportunidade', tipo: 'lista', obrigatorio: false, opcoes: ['Portal de compras', 'Diário oficial', 'Convite direto', 'Cliente recorrente', 'Indicação', 'Prospecção ativa'] },
      ],
    },
    {
      id: 'lc_e2', nome: 'Análise do Edital',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['lc_c1', 'lc_c6', 'lc_c13'],
      permiteMoverPara: ['lc_e3', 'lc_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'lc_c10', nome: 'Exigências de Habilitação', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Atestado de capacidade técnica', 'Acervo do responsável técnico', 'Capital social mínimo', 'Índices contábeis', 'Certidões negativas', 'Garantia de proposta', 'Visita técnica obrigatória', 'Registro no CREA/CAU'] },
        { id: 'lc_c11', nome: 'Atendemos a habilitação?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não', 'Parcialmente'], coresOpcoes: { 'Sim': COR.verde, 'Não': COR.vermelho, 'Parcialmente': COR.amarelo } },
        { id: 'lc_c12', nome: 'Riscos Identificados', tipo: 'texto_longo', obrigatorio: false },
        { id: 'lc_c13', nome: 'Vamos participar?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'lc_c14', nome: 'Precisa de consórcio ou parceria?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'lc_c15', nome: 'Data da Visita Técnica', tipo: 'data', obrigatorio: false },
      ],
    },
    {
      id: 'lc_e3', nome: 'Orçamento e Composição',
      tempoMaximoHoras: 168,
      camposVisiveisNoCard: ['lc_c1', 'lc_c19', 'lc_c6'],
      permiteMoverPara: ['lc_e4', 'lc_e7'],
      permiteCriarCards: false,
      ordenacaoCards: 'vencimento_proximo',
      campos: [
        { id: 'lc_c16', nome: 'Custo Direto', tipo: 'valor', obrigatorio: false },
        { id: 'lc_c17', nome: 'Custo Indireto / Canteiro', tipo: 'valor', obrigatorio: false },
        { id: 'lc_c18', nome: 'BDI Aplicado (%)', tipo: 'numero', obrigatorio: false },
        { id: 'lc_c19', nome: 'Valor Total da Proposta', tipo: 'valor', obrigatorio: true },
        { id: 'lc_c20', nome: 'Margem Prevista (%)', tipo: 'numero', obrigatorio: false },
        { id: 'lc_c21', nome: 'Prazo de Execução Proposto', tipo: 'texto', obrigatorio: false },
        { id: 'lc_c22', nome: 'Planilha Orçamentária', tipo: 'anexo', obrigatorio: false },
        { id: 'lc_c23', nome: 'Cronograma Físico-Financeiro', tipo: 'anexo', obrigatorio: false },
        { id: 'lc_c24', nome: 'Progresso do Orçamento', tipo: 'progresso', obrigatorio: false },
        { id: 'lc_c25', nome: 'Orçamento concluído?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'lc_e4', nome: 'Aprovação da Diretoria',
      tempoMaximoHoras: 48,
      slaIgnorarFimDeSemana: true,
      camposVisiveisNoCard: ['lc_c1', 'lc_c19', 'lc_c26'],
      permiteMoverPara: ['lc_e5', 'lc_e7'],
      permiteCriarCards: false,
      limparCamposAoRetornar: ['lc_c26', 'lc_c28'],
      campos: [
        { id: 'lc_c26', nome: 'Aprovada para envio?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'lc_c27', nome: 'Valor Final Autorizado', tipo: 'valor', obrigatorio: false },
        { id: 'lc_c28', nome: 'Condicionantes da Diretoria', tipo: 'texto_longo', obrigatorio: false },
        { id: 'lc_c29', nome: 'Desconto Máximo Autorizado (%)', tipo: 'numero', obrigatorio: false },
      ],
    },
    {
      id: 'lc_e5', nome: 'Proposta Entregue',
      camposVisiveisNoCard: ['lc_c1', 'lc_c19', 'lc_c31'],
      permiteMoverPara: ['lc_e6', 'lc_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'lc_c30', nome: 'Data da Entrega', tipo: 'data', obrigatorio: false },
        { id: 'lc_c31', nome: 'Data da Sessão / Abertura', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'lc_c32', nome: 'Protocolo de Entrega', tipo: 'anexo', obrigatorio: false },
        { id: 'lc_c33', nome: 'Nossa Classificação', tipo: 'texto', obrigatorio: false },
        { id: 'lc_c34', nome: 'Valor do 1º Colocado', tipo: 'valor', obrigatorio: false },
        { id: 'lc_c35', nome: 'Fomos vencedores?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'lc_e6', nome: 'Contrato Assinado',
      camposVisiveisNoCard: ['lc_c1', 'lc_c27', 'lc_c36'],
      permiteCriarCards: false,
      campos: [
        { id: 'lc_c36', nome: 'Data da Assinatura', tipo: 'data', obrigatorio: false },
        { id: 'lc_c37', nome: 'Contrato Assinado (PDF)', tipo: 'anexo', obrigatorio: false },
        { id: 'lc_c38', nome: 'Garantia Contratual Apresentada', tipo: 'lista', obrigatorio: false, opcoes: ['Seguro-garantia', 'Fiança bancária', 'Caução', 'Não exigida'] },
        { id: 'lc_c39', nome: 'Ordem de Serviço Recebida', tipo: 'anexo', obrigatorio: false },
        { id: 'lc_c40', nome: 'Data de Início Contratual', tipo: 'data', obrigatorio: false },
      ],
    },
    {
      id: 'lc_e7', nome: 'Não Prosseguiu',
      camposVisiveisNoCard: ['lc_c1', 'lc_c41'],
      permiteMoverPara: ['lc_e1'],
      permiteCriarCards: false,
      campos: [
        { id: 'lc_c41', nome: 'Motivo', tipo: 'lista', obrigatorio: true, opcoes: ['Perdemos no preço', 'Inabilitados', 'Não atendemos exigências', 'Decidimos não participar', 'Margem insuficiente', 'Licitação cancelada', 'Prazo inviável'], coresOpcoes: { 'Perdemos no preço': COR.amarelo, 'Inabilitados': COR.vermelho, 'Licitação cancelada': COR.cinza } },
        { id: 'lc_c42', nome: 'Detalhamento', tipo: 'texto_longo', obrigatorio: false },
        { id: 'lc_c43', nome: 'Diferença para o Vencedor (%)', tipo: 'numero', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Decisão de participar abre o orçamento',
      etapaOrigemId: 'lc_e2',
      condicao: { campoId: 'lc_c13', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'lc_e3',
      etapaDestinoSenaoId: 'lc_e7',
    },
    {
      tipo: 'mover',
      nome: 'Orçamento fechado vai para a diretoria',
      etapaOrigemId: 'lc_e3',
      condicao: { campoId: 'lc_c25', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'lc_e4',
    },
    {
      tipo: 'mover',
      nome: 'Aprovada segue para entrega',
      etapaOrigemId: 'lc_e4',
      condicao: { campoId: 'lc_c26', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'lc_e5',
      etapaDestinoSenaoId: 'lc_e7',
    },
    {
      tipo: 'mover',
      nome: 'Vencemos vira contrato',
      etapaOrigemId: 'lc_e5',
      condicao: { campoId: 'lc_c35', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'lc_e6',
      etapaDestinoSenaoId: 'lc_e7',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Riscos aparecem quando a habilitação não é plena',
      etapaOrigemId: 'lc_e2',
      condicao: { campoId: 'lc_c11', operador: 'diferente', valor: 'Sim' },
      camposAfetadosIds: ['lc_c12'],
    },
  ],
  cards: [
    { id: 'lc_card1', titulo: 'Reforma da Escola Municipal Central', etapaId: 'lc_e3', etiquetas: ['Pública', 'Prazo Curto'], valores: { lc_c1: 'Reforma da Escola Municipal Central', lc_c2: 'Prefeitura Municipal', lc_c3: 'Tomada de preços', lc_c4: 'TP 018/2026', lc_c7: 2900000, lc_c19: 2740000, lc_c18: 24, lc_c24: 60 } },
    { id: 'lc_card2', titulo: 'Construção do CD Regional', etapaId: 'lc_e4', etiquetas: ['Privada'], valores: { lc_c1: 'Construção do CD Regional', lc_c2: 'Transportes Andrade', lc_c3: 'Convite privado', lc_c7: 8000000, lc_c19: 7650000, lc_c20: 14 } },
    { id: 'lc_card3', titulo: 'Pavimentação do Distrito Industrial', etapaId: 'lc_e5', etiquetas: ['Pública'], valores: { lc_c1: 'Pavimentação do Distrito Industrial', lc_c2: 'Governo do Estado', lc_c3: 'Concorrência pública', lc_c4: 'CP 004/2026', lc_c19: 14200000, lc_c33: '2º colocado', lc_c34: 13850000 } },
    { id: 'lc_card4', titulo: 'Ampliação do Hospital Regional', etapaId: 'lc_e2', etiquetas: ['Pública', 'Consórcio'], valores: { lc_c1: 'Ampliação do Hospital Regional', lc_c2: 'Secretaria de Saúde', lc_c3: 'RDC', lc_c7: 31000000, lc_c11: 'Parcialmente', lc_c14: 'Sim', lc_c12: 'Atestado de capacidade técnica exige 12.000m² e temos 8.400m². Buscar consórcio.' } },
    { id: 'lc_card5', titulo: 'Galpão industrial - Metalúrgica Souza', etapaId: 'lc_e6', etiquetas: ['Privada'], valores: { lc_c1: 'Galpão industrial - Metalúrgica Souza', lc_c2: 'Metalúrgica Souza', lc_c3: 'Cotação direta', lc_c19: 4300000, lc_c27: 4180000, lc_c38: 'Seguro-garantia' } },
    { id: 'lc_card6', titulo: 'Praça e mobiliário urbano - Bairro Sul', etapaId: 'lc_e1', etiquetas: ['Pública'], valores: { lc_c1: 'Praça e mobiliário urbano - Bairro Sul', lc_c2: 'Prefeitura Municipal', lc_c3: 'Pregão eletrônico', lc_c7: 1100000, lc_c9: 'Portal de compras' } },
    { id: 'lc_card7', titulo: 'Terminal rodoviário - Lote 2', etapaId: 'lc_e7', valores: { lc_c1: 'Terminal rodoviário - Lote 2', lc_c2: 'Governo do Estado', lc_c3: 'Concorrência pública', lc_c41: 'Perdemos no preço', lc_c43: 6.8, lc_c42: 'Vencedor entrou 6,8% abaixo. Revisar BDI para obras públicas de porte.' } },
  ],
  tour: [
    '📊 Toda concorrência disputada vira um card — inclusive as que você decide não participar.',
    '1️⃣ "Oportunidade": edital anexado e a data de entrega como vencimento do card.',
    '2️⃣ "Análise do Edital": checklist de habilitação e o go/no-go registrado.',
    '3️⃣ "Orçamento": custo direto, indireto, BDI e margem no mesmo lugar.',
    '4️⃣ "Aprovação da Diretoria": desconto máximo autorizado fica escrito antes da sessão.',
    '5️⃣ "Proposta Entregue": classificação e valor do 1º colocado registrados.',
    '📌 "Não Prosseguiu" guarda a diferença percentual para o vencedor — é o que calibra o próximo BDI.',
  ],
  etapasDicas: [
    { quemFaz: 'Comercial / Novos Negócios', objetivo: 'Captar e registrar toda oportunidade com o prazo real.' },
    { quemFaz: 'Engenharia / Jurídico', objetivo: 'Decidir cedo se dá para participar — orçamento custa caro.', automacoes: ['Já configurado: decisão de não participar arquiva com motivo'] },
    { quemFaz: 'Orçamentista', objetivo: 'Fechar composição com BDI defensável.' },
    { quemFaz: 'Diretoria', objetivo: 'Autorizar o valor e o limite de desconto na sessão.' },
    { quemFaz: 'Comercial', objetivo: 'Registrar classificação e concorrentes.' },
    { quemFaz: 'Jurídico / Contratos', objetivo: 'Garantia contratual e ordem de serviço guardadas.', conexoes: ['Ligue à "Execução de Obra" para iniciar o planejamento'] },
    { quemFaz: 'Comercial / Orçamento', objetivo: 'Analisar a perda para calibrar o próximo orçamento.' },
  ],
};

const medicaoContrato: DefaultTemplate = {
  id: 'tpl_medicao_contrato',
  name: 'Medição e Faturamento do Contrato',
  descricao: 'O lado da receita: boletim de medição apresentado ao cliente, aprovação da fiscalização, glosas, emissão da nota fiscal, retenções contratuais e recebimento. O espelho da medição do empreiteiro.',
  categoria: 'obras',
  icone: '💵',
  etiquetas: [
    { nome: 'Cliente Público', cor: COR.azul },
    { nome: 'Glosa do Cliente', cor: COR.amarelo },
    { nome: 'Atrasado', cor: COR.vermelho },
  ],
  etapas: [
    {
      id: 'mc_e1', nome: 'Boletim Preparado',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['mc_c1', 'mc_c2', 'mc_c6'],
      permiteMoverPara: ['mc_e2'],
      campos: [
        { id: 'mc_c1', nome: 'Identificação da Medição', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'mc_c2', nome: 'Contrato / Obra', tipo: 'texto', obrigatorio: true },
        { id: 'mc_c3', nome: 'Cliente / Contratante', tipo: 'texto', obrigatorio: true },
        { id: 'mc_c4', nome: 'Período Medido', tipo: 'texto', obrigatorio: true },
        { id: 'mc_c5', nome: 'Nº da Medição', tipo: 'numero', obrigatorio: false },
        { id: 'mc_c6', nome: 'Valor Bruto Medido', tipo: 'valor', obrigatorio: true },
        { id: 'mc_c7', nome: '% Físico Acumulado', tipo: 'progresso', obrigatorio: false },
        { id: 'mc_c8', nome: 'Serviços do Período', tipo: 'texto_longo', obrigatorio: false },
        { id: 'mc_c9', nome: 'Planilha e Memória de Cálculo', tipo: 'anexo', obrigatorio: false },
        { id: 'mc_c10', nome: 'Relatório Fotográfico', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'mc_e2', nome: 'Aprovação do Cliente',
      tempoMaximoHoras: 168,
      camposVisiveisNoCard: ['mc_c1', 'mc_c6', 'mc_c11'],
      permiteMoverPara: ['mc_e3', 'mc_e6'],
      permiteCriarCards: false,
      ordenacaoCards: 'vencimento_proximo',
      campos: [
        { id: 'mc_c11', nome: 'Medição aprovada?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'mc_c12', nome: 'Prazo de Retorno do Cliente', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'mc_c13', nome: 'Fiscal / Responsável do Cliente', tipo: 'texto', obrigatorio: false },
        { id: 'mc_c14', nome: 'Valor Glosado pelo Cliente', tipo: 'valor', obrigatorio: false },
        { id: 'mc_c15', nome: 'Motivo da Glosa', tipo: 'texto_longo', obrigatorio: false },
        { id: 'mc_c16', nome: 'Boletim Assinado', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'mc_e3', nome: 'Emissão da Nota Fiscal',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['mc_c1', 'mc_c20', 'mc_c18'],
      permiteMoverPara: ['mc_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'mc_c17', nome: 'Nº da Nota Fiscal', tipo: 'texto', obrigatorio: false },
        { id: 'mc_c18', nome: 'Data de Emissão', tipo: 'data', obrigatorio: false },
        { id: 'mc_c19', nome: 'Retenções (INSS, ISS, IR)', tipo: 'valor', obrigatorio: false },
        { id: 'mc_c20', nome: 'Valor Líquido a Receber', tipo: 'valor', obrigatorio: true },
        { id: 'mc_c21', nome: 'Nota Fiscal (arquivo)', tipo: 'anexo', obrigatorio: false },
        { id: 'mc_c22', nome: 'NF emitida?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'mc_e4', nome: 'Aguardando Pagamento',
      camposVisiveisNoCard: ['mc_c1', 'mc_c20', 'mc_c23'],
      permiteMoverPara: ['mc_e5'],
      permiteCriarCards: false,
      ordenacaoCards: 'vencimento_proximo',
      campos: [
        { id: 'mc_c23', nome: 'Vencimento', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'mc_c24', nome: 'Dias em Atraso', tipo: 'numero', obrigatorio: false },
        { id: 'mc_c25', nome: 'Tratativas de Cobrança', tipo: 'texto_longo', obrigatorio: false },
        { id: 'mc_c26', nome: 'Pagamento recebido?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'mc_e5', nome: 'Recebido',
      camposVisiveisNoCard: ['mc_c1', 'mc_c27', 'mc_c28'],
      permiteCriarCards: false,
      campos: [
        { id: 'mc_c27', nome: 'Data do Recebimento', tipo: 'data', obrigatorio: false },
        { id: 'mc_c28', nome: 'Valor Efetivamente Recebido', tipo: 'valor', obrigatorio: false },
        { id: 'mc_c29', nome: 'Comprovante', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'mc_e6', nome: 'Em Revisão',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['mc_c1', 'mc_c30'],
      permiteMoverPara: ['mc_e1', 'mc_e2'],
      permiteCriarCards: false,
      campos: [
        { id: 'mc_c30', nome: 'Ponto Contestado', tipo: 'texto_longo', obrigatorio: true },
        { id: 'mc_c31', nome: 'Vamos contestar a glosa?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'mc_c32', nome: 'Prazo para Reapresentar', tipo: 'data_vencimento', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Medição aprovada libera o faturamento',
      etapaOrigemId: 'mc_e2',
      condicao: { campoId: 'mc_c11', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'mc_e3',
      etapaDestinoSenaoId: 'mc_e6',
    },
    {
      tipo: 'mover',
      nome: 'NF emitida entra na régua de cobrança',
      etapaOrigemId: 'mc_e3',
      condicao: { campoId: 'mc_c22', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'mc_e4',
    },
    {
      tipo: 'mover',
      nome: 'Pagamento confirmado encerra a medição',
      etapaOrigemId: 'mc_e4',
      condicao: { campoId: 'mc_c26', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'mc_e5',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Campos de glosa quando o cliente não aprova',
      etapaOrigemId: 'mc_e2',
      condicao: { campoId: 'mc_c11', operador: 'igual', valor: 'Não' },
      camposAfetadosIds: ['mc_c14', 'mc_c15'],
    },
  ],
  cards: [
    { id: 'mc_card1', titulo: 'Medição 07 - Escola Municipal', etapaId: 'mc_e2', etiquetas: ['Cliente Público', 'Glosa do Cliente'], valores: { mc_c1: 'Medição 07 - Escola Municipal', mc_c2: 'Reforma Escola Central', mc_c3: 'Prefeitura Municipal', mc_c4: '01/07 a 31/07', mc_c5: 7, mc_c6: 412000, mc_c11: 'Não', mc_c14: 38000, mc_c15: 'Fiscalização não aceitou o item de forro sem ensaio de resistência ao fogo.' } },
    { id: 'mc_card2', titulo: 'Medição 03 - CD Sul', etapaId: 'mc_e4', etiquetas: ['Atrasado'], valores: { mc_c1: 'Medição 03 - CD Sul', mc_c2: 'Galpão Logístico CD Sul', mc_c3: 'Transportes Andrade', mc_c4: '01/06 a 30/06', mc_c6: 680000, mc_c20: 631000, mc_c24: 18 } },
    { id: 'mc_card3', titulo: 'Medição 11 - Edifício Prime', etapaId: 'mc_e3', valores: { mc_c1: 'Medição 11 - Edifício Prime', mc_c2: 'Edifício Comercial Prime', mc_c3: 'Prime Empreendimentos', mc_c4: '01/07 a 31/07', mc_c6: 940000, mc_c19: 62000, mc_c20: 878000 } },
    { id: 'mc_card4', titulo: 'Medição 02 - Centro Clínico', etapaId: 'mc_e5', valores: { mc_c1: 'Medição 02 - Centro Clínico', mc_c2: 'Centro Clínico Bela Vista', mc_c3: 'Clínica Bela Vista', mc_c4: '01/06 a 30/06', mc_c6: 385000, mc_c28: 361000 } },
    { id: 'mc_card5', titulo: 'Medição 01 - Metalúrgica Souza', etapaId: 'mc_e1', valores: { mc_c1: 'Medição 01 - Metalúrgica Souza', mc_c2: 'Ampliação da Fábrica', mc_c3: 'Metalúrgica Souza', mc_c4: '01/08 a 31/08', mc_c6: 274000, mc_c7: 12 } },
    { id: 'mc_card6', titulo: 'Medição 06 - Pavimentação', etapaId: 'mc_e6', etiquetas: ['Cliente Público'], valores: { mc_c1: 'Medição 06 - Pavimentação', mc_c2: 'Distrito Industrial', mc_c3: 'Governo do Estado', mc_c4: '01/07 a 31/07', mc_c6: 1240000, mc_c30: 'Quantitativo de base divergente da fiscalização em 340m³.', mc_c31: 'Sim' } },
  ],
  tour: [
    '💵 A receita da obra tratada com o mesmo rigor da despesa.',
    '1️⃣ "Boletim Preparado": memória de cálculo e relatório fotográfico anexados.',
    '2️⃣ "Aprovação do Cliente": prazo de retorno vira vencimento — cliente que não responde aparece no topo.',
    '3️⃣ "Emissão da NF": retenções de INSS/ISS/IR já descontadas no líquido.',
    '4️⃣ "Aguardando Pagamento": dias em atraso e tratativas de cobrança no card.',
    '✅ "Recebido": comprovante junto da medição que o originou.',
    '⚠️ "Em Revisão": glosa do cliente com decisão de contestar ou não.',
  ],
  etapasDicas: [
    { quemFaz: 'Engenheiro / Planejamento', objetivo: 'Montar o boletim com memória de cálculo defensável.' },
    { quemFaz: 'Engenharia + Fiscalização do cliente', objetivo: 'Fechar a medição com assinatura do fiscal.', automacoes: ['Já configurado: reprovada vai para revisão com a glosa'] },
    { quemFaz: 'Fiscal / Faturamento', objetivo: 'Emitir a NF só depois do boletim assinado.' },
    { quemFaz: 'Financeiro', objetivo: 'Cobrar antes de virar inadimplência.', conexoes: ['Ligue ao Contas a Receber para a régua de cobrança'] },
    { quemFaz: 'Financeiro', objetivo: 'Conferir se o valor recebido bate com o faturado.' },
    { quemFaz: 'Engenharia / Contratos', objetivo: 'Decidir entre aceitar a glosa ou abrir pleito.', conexoes: ['Ligue a "Aditivos e Pleitos" quando a glosa virar disputa'] },
  ],
};

const aditivosPleitos: DefaultTemplate = {
  id: 'tpl_aditivos_pleitos',
  name: 'Aditivos e Pleitos Contratuais',
  descricao: 'Todo fato que muda prazo ou preço vira card: serviço extra, alteração de projeto, chuva excepcional, atraso do cliente. Fundamentação, cálculo, protocolo e acompanhamento até o aditivo assinado.',
  categoria: 'obras',
  icone: '📝',
  etiquetas: [
    { nome: 'Prazo', cor: COR.azul },
    { nome: 'Preço', cor: COR.verde },
    { nome: 'Risco de Prescrição', cor: COR.vermelho },
  ],
  etapas: [
    {
      id: 'ad_e1', nome: 'Fato Gerador',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['ad_c1', 'ad_c3', 'ad_c5'],
      permiteMoverPara: ['ad_e2'],
      campos: [
        { id: 'ad_c1', nome: 'Descrição do Fato', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'ad_c2', nome: 'Contrato / Obra', tipo: 'texto', obrigatorio: true },
        { id: 'ad_c3', nome: 'Natureza', tipo: 'lista', obrigatorio: true, opcoes: ['Serviço extra', 'Alteração de projeto', 'Acréscimo de quantitativo', 'Supressão de serviço', 'Atraso do contratante', 'Evento climático', 'Reequilíbrio econômico', 'Prorrogação de prazo'], coresOpcoes: { 'Serviço extra': COR.verde, 'Prorrogação de prazo': COR.azul, 'Reequilíbrio econômico': COR.amarelo } },
        { id: 'ad_c4', nome: 'Data do Fato', tipo: 'data', obrigatorio: true },
        { id: 'ad_c5', nome: 'Impacto', tipo: 'lista', obrigatorio: true, opcoes: ['Só prazo', 'Só preço', 'Prazo e preço'], coresOpcoes: { 'Só prazo': COR.azul, 'Só preço': COR.verde, 'Prazo e preço': COR.amarelo } },
        { id: 'ad_c6', nome: 'Relato Detalhado', tipo: 'texto_longo', obrigatorio: true },
        { id: 'ad_c7', nome: 'Evidências (fotos, e-mails, diário)', tipo: 'anexo', obrigatorio: false },
        { id: 'ad_c8', nome: 'Prazo Contratual para Notificar', tipo: 'data_vencimento', obrigatorio: false },
      ],
    },
    {
      id: 'ad_e2', nome: 'Fundamentação e Cálculo',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['ad_c1', 'ad_c10', 'ad_c11'],
      permiteMoverPara: ['ad_e3', 'ad_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'ad_c9', nome: 'Cláusula Contratual de Amparo', tipo: 'texto', obrigatorio: false },
        { id: 'ad_c10', nome: 'Valor Pleiteado', tipo: 'valor', obrigatorio: false },
        { id: 'ad_c11', nome: 'Dias de Prazo Pleiteados', tipo: 'numero', obrigatorio: false },
        { id: 'ad_c12', nome: 'Memória de Cálculo', tipo: 'anexo', obrigatorio: false },
        { id: 'ad_c13', nome: 'Parecer Técnico', tipo: 'texto_longo', obrigatorio: false },
        { id: 'ad_c14', nome: 'Fundamentação suficiente?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'ad_e3', nome: 'Aprovação Interna',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['ad_c1', 'ad_c10', 'ad_c15'],
      permiteMoverPara: ['ad_e4', 'ad_e7'],
      permiteCriarCards: false,
      limparCamposAoRetornar: ['ad_c15', 'ad_c16'],
      campos: [
        { id: 'ad_c15', nome: 'Aprovado para protocolar?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'ad_c16', nome: 'Orientação da Diretoria', tipo: 'texto_longo', obrigatorio: false },
        { id: 'ad_c17', nome: 'Estratégia', tipo: 'lista', obrigatorio: false, opcoes: ['Pleito formal', 'Negociação amigável', 'Aditivo direto', 'Reserva de direito'] },
      ],
    },
    {
      id: 'ad_e4', nome: 'Protocolado no Cliente',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['ad_c1', 'ad_c18', 'ad_c20'],
      permiteMoverPara: ['ad_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'ad_c18', nome: 'Nº do Protocolo / Ofício', tipo: 'texto', obrigatorio: false },
        { id: 'ad_c19', nome: 'Data do Protocolo', tipo: 'data', obrigatorio: false },
        { id: 'ad_c20', nome: 'Prazo de Resposta do Cliente', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'ad_c21', nome: 'Ofício Protocolado', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'ad_e5', nome: 'Em Análise do Cliente',
      camposVisiveisNoCard: ['ad_c1', 'ad_c22', 'ad_c20'],
      permiteMoverPara: ['ad_e6', 'ad_e7'],
      permiteCriarCards: false,
      ordenacaoCards: 'vencimento_proximo',
      campos: [
        { id: 'ad_c22', nome: 'Situação', tipo: 'lista', obrigatorio: false, opcoes: ['Aguardando análise', 'Em negociação', 'Aguardando parecer jurídico', 'Aguardando assinatura'], coresOpcoes: { 'Em negociação': COR.amarelo } },
        { id: 'ad_c23', nome: 'Valor Sinalizado pelo Cliente', tipo: 'valor', obrigatorio: false },
        { id: 'ad_c24', nome: 'Histórico de Tratativas', tipo: 'texto_longo', obrigatorio: false },
        { id: 'ad_c25', nome: 'Aditivo aprovado pelo cliente?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'ad_e6', nome: 'Aditivo Assinado',
      camposVisiveisNoCard: ['ad_c1', 'ad_c26', 'ad_c27'],
      permiteCriarCards: false,
      campos: [
        { id: 'ad_c26', nome: 'Valor Aprovado', tipo: 'valor', obrigatorio: false },
        { id: 'ad_c27', nome: 'Dias de Prazo Concedidos', tipo: 'numero', obrigatorio: false },
        { id: 'ad_c28', nome: 'Nº do Termo Aditivo', tipo: 'texto', obrigatorio: false },
        { id: 'ad_c29', nome: 'Data da Assinatura', tipo: 'data', obrigatorio: false },
        { id: 'ad_c30', nome: 'Termo Aditivo (PDF)', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'ad_e7', nome: 'Indeferido / Arquivado',
      camposVisiveisNoCard: ['ad_c1', 'ad_c31'],
      permiteMoverPara: ['ad_e2'],
      permiteCriarCards: false,
      campos: [
        { id: 'ad_c31', nome: 'Motivo', tipo: 'lista', obrigatorio: true, opcoes: ['Cliente indeferiu', 'Sem amparo contratual', 'Prazo de notificação perdido', 'Fundamentação insuficiente', 'Decisão interna de não pleitear', 'Absorvido em negociação'], coresOpcoes: { 'Prazo de notificação perdido': COR.vermelho, 'Sem amparo contratual': COR.vermelho } },
        { id: 'ad_c32', nome: 'Detalhamento', tipo: 'texto_longo', obrigatorio: false },
        { id: 'ad_c33', nome: 'Vai para arbitragem/judicial?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Fundamentação pronta vai para aprovação interna',
      etapaOrigemId: 'ad_e2',
      condicao: { campoId: 'ad_c14', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'ad_e3',
      etapaDestinoSenaoId: 'ad_e7',
    },
    {
      tipo: 'mover',
      nome: 'Aprovado internamente vai para protocolo',
      etapaOrigemId: 'ad_e3',
      condicao: { campoId: 'ad_c15', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'ad_e4',
      etapaDestinoSenaoId: 'ad_e7',
    },
    {
      tipo: 'mover',
      nome: 'Cliente aprovou vira termo aditivo',
      etapaOrigemId: 'ad_e5',
      condicao: { campoId: 'ad_c25', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'ad_e6',
      etapaDestinoSenaoId: 'ad_e7',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Caminho judicial só quando indeferido',
      etapaOrigemId: 'ad_e7',
      condicao: { campoId: 'ad_c31', operador: 'igual', valor: 'Cliente indeferiu' },
      camposAfetadosIds: ['ad_c33'],
    },
  ],
  cards: [
    { id: 'ad_card1', titulo: 'Chuvas acima da média em julho', etapaId: 'ad_e5', etiquetas: ['Prazo'], valores: { ad_c1: 'Chuvas acima da média em julho', ad_c2: 'Pavimentação Distrito Industrial', ad_c3: 'Evento climático', ad_c5: 'Só prazo', ad_c11: 22, ad_c18: 'OF 114/2026', ad_c22: 'Aguardando parecer jurídico' } },
    { id: 'ad_card2', titulo: 'Reforço de fundação não previsto em sondagem', etapaId: 'ad_e2', etiquetas: ['Preço', 'Risco de Prescrição'], valores: { ad_c1: 'Reforço de fundação não previsto em sondagem', ad_c2: 'Centro Clínico Bela Vista', ad_c3: 'Serviço extra', ad_c5: 'Prazo e preço', ad_c10: 340000, ad_c11: 30 } },
    { id: 'ad_card3', titulo: 'Alteração do layout do 2º pavimento', etapaId: 'ad_e6', etiquetas: ['Preço'], valores: { ad_c1: 'Alteração do layout do 2º pavimento', ad_c2: 'Edifício Comercial Prime', ad_c3: 'Alteração de projeto', ad_c5: 'Prazo e preço', ad_c10: 186000, ad_c26: 172000, ad_c27: 15, ad_c28: 'TA 03/2026' } },
    { id: 'ad_card4', titulo: 'Atraso na liberação da frente de serviço', etapaId: 'ad_e3', etiquetas: ['Prazo'], valores: { ad_c1: 'Atraso na liberação da frente de serviço', ad_c2: 'Galpão Logístico CD Sul', ad_c3: 'Atraso do contratante', ad_c5: 'Só prazo', ad_c11: 41, ad_c14: 'Sim' } },
    { id: 'ad_card5', titulo: 'Acréscimo de 18% no quantitativo de aço', etapaId: 'ad_e4', etiquetas: ['Preço'], valores: { ad_c1: 'Acréscimo de 18% no quantitativo de aço', ad_c2: 'Reforma Escola Central', ad_c3: 'Acréscimo de quantitativo', ad_c5: 'Só preço', ad_c10: 96000, ad_c18: 'OF 122/2026' } },
    { id: 'ad_card6', titulo: 'Reequilíbrio pelo aumento do cimento', etapaId: 'ad_e1', valores: { ad_c1: 'Reequilíbrio pelo aumento do cimento', ad_c2: 'Pavimentação Distrito Industrial', ad_c3: 'Reequilíbrio econômico', ad_c5: 'Só preço' } },
    { id: 'ad_card7', titulo: 'Serviço extra de drenagem', etapaId: 'ad_e7', valores: { ad_c1: 'Serviço extra de drenagem', ad_c2: 'Condomínio Alto da Serra', ad_c3: 'Serviço extra', ad_c5: 'Só preço', ad_c31: 'Prazo de notificação perdido', ad_c32: 'Fato ocorreu em maio e só foi registrado em agosto. Contrato exige notificação em 15 dias.' } },
  ],
  tour: [
    '📝 Fato que muda prazo ou preço vira card no dia em que acontece — não no fim da obra.',
    '1️⃣ "Fato Gerador": evidência anexada e o prazo contratual de notificação como vencimento.',
    '2️⃣ "Fundamentação": cláusula de amparo, cálculo e parecer técnico.',
    '3️⃣ "Aprovação Interna": diretoria escolhe entre pleito formal, negociação ou reserva de direito.',
    '4️⃣ "Protocolado": número do ofício e prazo de resposta do cliente registrados.',
    '5️⃣ "Em Análise": tratativas documentadas — é o que sustenta arbitragem depois.',
    '⚠️ Repare no card de exemplo arquivado por prazo de notificação perdido. É assim que construtora perde dinheiro.',
  ],
  etapasDicas: [
    { quemFaz: 'Engenheiro da Obra', objetivo: 'Registrar no dia do fato, com foto e diário — depois vira palavra contra palavra.' },
    { quemFaz: 'Planejamento / Orçamento', objetivo: 'Calcular impacto real de prazo e custo.', automacoes: ['Já configurado: sem fundamentação o pleito é arquivado'] },
    { quemFaz: 'Diretoria / Jurídico', objetivo: 'Definir a estratégia antes de protocolar.' },
    { quemFaz: 'Contratos / Administrativo', objetivo: 'Protocolar dentro do prazo contratual.' },
    { quemFaz: 'Contratos / Engenharia', objetivo: 'Documentar cada tratativa com o cliente.', automacoes: ['Já configurado: aprovado vira termo aditivo'] },
    { quemFaz: 'Jurídico', objetivo: 'Guardar o termo e atualizar o contrato base.', conexoes: ['Ligue à "Medição e Faturamento" para refletir o novo valor'] },
    { quemFaz: 'Jurídico / Diretoria', objetivo: 'Decidir se encerra ou escala para arbitragem.' },
  ],
};

const coordenacaoProjetos: DefaultTemplate = {
  id: 'tpl_coordenacao_projetos',
  name: 'Coordenação e Revisão de Projetos',
  descricao: 'Controle de pranchas e revisões: contratação do projetista, desenvolvimento, compatibilização entre disciplinas, análise crítica e liberação para obra. Obra nunca mais executa por prancha vencida.',
  categoria: 'obras',
  icone: '📁',
  etiquetas: [
    { nome: 'Trava a Obra', cor: COR.vermelho },
    { nome: 'Compatibilização', cor: COR.amarelo },
    { nome: 'As Built', cor: COR.ciano },
  ],
  etapas: [
    {
      id: 'pj_e1', nome: 'Demanda de Projeto',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['pj_c1', 'pj_c3', 'pj_c6'],
      permiteMoverPara: ['pj_e2'],
      campos: [
        { id: 'pj_c1', nome: 'Projeto', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'pj_c2', nome: 'Obra / Empreendimento', tipo: 'texto', obrigatorio: true },
        { id: 'pj_c3', nome: 'Disciplina', tipo: 'lista', obrigatorio: true, opcoes: ['Arquitetura', 'Estrutural', 'Elétrico', 'Hidrossanitário', 'Climatização', 'Incêndio', 'Fundações', 'Impermeabilização', 'Paisagismo', 'Interiores', 'Terraplenagem'] },
        { id: 'pj_c4', nome: 'Projetista / Escritório', tipo: 'texto', obrigatorio: false },
        { id: 'pj_c5', nome: 'Escopo Solicitado', tipo: 'texto_longo', obrigatorio: false },
        { id: 'pj_c6', nome: 'Prazo Necessário em Obra', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'pj_c7', nome: 'Trava frente de serviço?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'pj_c8', nome: 'Valor Contratado', tipo: 'valor', obrigatorio: false },
      ],
    },
    {
      id: 'pj_e2', nome: 'Em Desenvolvimento',
      camposVisiveisNoCard: ['pj_c1', 'pj_c9', 'pj_c6'],
      permiteMoverPara: ['pj_e3'],
      permiteCriarCards: false,
      ordenacaoCards: 'vencimento_proximo',
      campos: [
        { id: 'pj_c9', nome: 'Progresso', tipo: 'progresso', obrigatorio: false },
        { id: 'pj_c10', nome: 'Revisão Atual', tipo: 'texto', obrigatorio: false },
        { id: 'pj_c11', nome: 'Arquivos do Projeto', tipo: 'anexo', obrigatorio: false },
        { id: 'pj_c12', nome: 'Entregue pelo projetista?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'pj_e3', nome: 'Compatibilização',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['pj_c1', 'pj_c14'],
      permiteMoverPara: ['pj_e4', 'pj_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'pj_c13', nome: 'Disciplinas Cruzadas', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Arquitetura x Estrutural', 'Estrutural x Hidráulico', 'Estrutural x Elétrico', 'Hidráulico x Climatização', 'Incêndio x Arquitetura', 'Fundação x Terreno'] },
        { id: 'pj_c14', nome: 'Encontrou interferência?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'pj_c15', nome: 'Interferências Listadas', tipo: 'texto_longo', obrigatorio: false },
        { id: 'pj_c16', nome: 'Relatório de Compatibilização', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'pj_e4', nome: 'Análise Crítica',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['pj_c1', 'pj_c17'],
      permiteMoverPara: ['pj_e5', 'pj_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'pj_c17', nome: 'Projeto aprovado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'pj_c18', nome: 'Analisado por', tipo: 'texto', obrigatorio: false },
        { id: 'pj_c19', nome: 'Apontamentos', tipo: 'texto_longo', obrigatorio: false },
        { id: 'pj_c20', nome: 'ART / RRT do Projeto', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'pj_e5', nome: 'Liberado para Obra',
      camposVisiveisNoCard: ['pj_c1', 'pj_c21', 'pj_c22'],
      permiteMoverPara: ['pj_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'pj_c21', nome: 'Revisão Liberada', tipo: 'texto', obrigatorio: false },
        { id: 'pj_c22', nome: 'Data da Liberação', tipo: 'data', obrigatorio: false },
        { id: 'pj_c23', nome: 'Prancha Liberada (PDF)', tipo: 'anexo', obrigatorio: false },
        { id: 'pj_c24', nome: 'Obra notificada da revisão?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'pj_c25', nome: 'Revisões anteriores recolhidas?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'pj_e6', nome: 'Revisão Solicitada',
      tempoMaximoHoras: 96,
      camposVisiveisNoCard: ['pj_c1', 'pj_c26'],
      permiteMoverPara: ['pj_e2'],
      permiteCriarCards: false,
      campos: [
        { id: 'pj_c26', nome: 'Motivo da Revisão', tipo: 'lista', obrigatorio: true, opcoes: ['Interferência entre disciplinas', 'Apontamento da análise crítica', 'Solicitação do cliente', 'Exigência de órgão', 'Erro executivo detectado em obra', 'Mudança de escopo'], coresOpcoes: { 'Erro executivo detectado em obra': COR.vermelho } },
        { id: 'pj_c27', nome: 'O que deve ser revisado', tipo: 'texto_longo', obrigatorio: true },
        { id: 'pj_c28', nome: 'Prazo para Nova Versão', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'pj_c29', nome: 'Gera custo adicional?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Projeto entregue vai para compatibilização',
      etapaOrigemId: 'pj_e2',
      condicao: { campoId: 'pj_c12', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'pj_e3',
    },
    {
      tipo: 'mover',
      nome: 'Sem interferência segue para análise crítica',
      etapaOrigemId: 'pj_e3',
      condicao: { campoId: 'pj_c14', operador: 'igual', valor: 'Não' },
      etapaDestinoId: 'pj_e4',
      etapaDestinoSenaoId: 'pj_e6',
    },
    {
      tipo: 'mover',
      nome: 'Aprovado libera para a obra',
      etapaOrigemId: 'pj_e4',
      condicao: { campoId: 'pj_c17', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'pj_e5',
      etapaDestinoSenaoId: 'pj_e6',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Listar interferências quando houver',
      etapaOrigemId: 'pj_e3',
      condicao: { campoId: 'pj_c14', operador: 'igual', valor: 'Sim' },
      camposAfetadosIds: ['pj_c15'],
    },
  ],
  cards: [
    { id: 'pj_card1', titulo: 'Estrutural - Torre A - Rev. 04', etapaId: 'pj_e3', etiquetas: ['Compatibilização', 'Trava a Obra'], valores: { pj_c1: 'Estrutural - Torre A - Rev. 04', pj_c2: 'Residencial Vista Verde', pj_c3: 'Estrutural', pj_c4: 'Calculart Engenharia', pj_c7: 'Sim', pj_c14: 'Sim', pj_c15: 'Furo de passagem hidráulica conflita com viga V12 no 4º pavimento.' } },
    { id: 'pj_card2', titulo: 'Elétrico - CD Sul - Rev. 02', etapaId: 'pj_e5', valores: { pj_c1: 'Elétrico - CD Sul - Rev. 02', pj_c2: 'Galpão Logístico CD Sul', pj_c3: 'Elétrico', pj_c21: 'R02', pj_c24: 'Sim', pj_c25: 'Sim' } },
    { id: 'pj_card3', titulo: 'Incêndio - Edifício Prime', etapaId: 'pj_e4', valores: { pj_c1: 'Incêndio - Edifício Prime', pj_c2: 'Edifício Comercial Prime', pj_c3: 'Incêndio', pj_c4: 'FireProj', pj_c17: 'Não', pj_c19: 'Falta detalhamento da pressurização da escada.' } },
    { id: 'pj_card4', titulo: 'Climatização - Centro Clínico', etapaId: 'pj_e2', valores: { pj_c1: 'Climatização - Centro Clínico', pj_c2: 'Centro Clínico Bela Vista', pj_c3: 'Climatização', pj_c9: 45 } },
    { id: 'pj_card5', titulo: 'Hidrossanitário - Alto da Serra', etapaId: 'pj_e6', etiquetas: ['Trava a Obra'], valores: { pj_c1: 'Hidrossanitário - Alto da Serra', pj_c2: 'Condomínio Alto da Serra', pj_c3: 'Hidrossanitário', pj_c26: 'Erro executivo detectado em obra', pj_c27: 'Caimento da rede de esgoto insuficiente no trecho das casas 12 a 20.', pj_c29: 'Sim' } },
    { id: 'pj_card6', titulo: 'As built elétrico - Reforma Matriz', etapaId: 'pj_e1', etiquetas: ['As Built'], valores: { pj_c1: 'As built elétrico - Reforma Matriz', pj_c2: 'Reforma da Loja Matriz', pj_c3: 'Elétrico', pj_c7: 'Não' } },
  ],
  tour: [
    '📁 Uma prancha por card, com a revisão vigente sempre visível.',
    '1️⃣ "Demanda": disciplina, projetista e a data em que a obra precisa da prancha.',
    '2️⃣ "Em Desenvolvimento": progresso e revisão atual acompanhados.',
    '3️⃣ "Compatibilização": achou interferência? o card vai direto para revisão.',
    '4️⃣ "Análise Crítica": aprovação com ART anexada.',
    '5️⃣ "Liberado para Obra": tem campo para confirmar que a revisão antiga foi recolhida do canteiro.',
    '🔁 "Revisão Solicitada": registra se a revisão gera custo adicional — vira pleito quando é culpa de terceiro.',
  ],
  etapasDicas: [
    { quemFaz: 'Coordenação de Projetos', objetivo: 'Amarrar a data da prancha ao cronograma da obra.' },
    { quemFaz: 'Projetista / Escritório', objetivo: 'Entregar com a revisão identificada.' },
    { quemFaz: 'Coordenador de Projetos', objetivo: 'Cruzar disciplinas antes da obra descobrir no concreto.', automacoes: ['Já configurado: interferência devolve para revisão'] },
    { quemFaz: 'Engenheiro / Coordenador', objetivo: 'Aprovar com ART recolhida.' },
    { quemFaz: 'Coordenação + Obra', objetivo: 'Garantir que o canteiro está com a revisão certa em mãos.', conexoes: ['Ligue à "Execução de Obra" — prancha vencida é retrabalho garantido'] },
    { quemFaz: 'Coordenação de Projetos', objetivo: 'Registrar motivo e custo de cada revisão.', conexoes: ['Ligue a "Aditivos e Pleitos" quando a revisão for causada pelo cliente'] },
  ],
};

const equipamentosFrota: DefaultTemplate = {
  id: 'tpl_equipamentos_frota',
  name: 'Equipamentos e Frota de Obra',
  descricao: 'Ciclo do maquinário: solicitação, decisão entre frota própria e locação, mobilização para o canteiro, operação com horímetro e preventiva, manutenção corretiva e desmobilização com vistoria.',
  categoria: 'obras',
  icone: '🚜',
  etiquetas: [
    { nome: 'Locado', cor: COR.amarelo },
    { nome: 'Frota Própria', cor: COR.azul },
    { nome: 'Parado / Quebrado', cor: COR.vermelho },
  ],
  etapas: [
    {
      id: 'eq_e1', nome: 'Solicitação',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['eq_c1', 'eq_c2', 'eq_c5'],
      permiteMoverPara: ['eq_e2'],
      campos: [
        { id: 'eq_c1', nome: 'Equipamento', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'eq_c2', nome: 'Obra / Centro de Custo', tipo: 'texto', obrigatorio: true },
        { id: 'eq_c3', nome: 'Tipo', tipo: 'lista', obrigatorio: true, opcoes: ['Escavadeira', 'Retroescavadeira', 'Caminhão', 'Betoneira', 'Grua / Guindaste', 'Compactador', 'Gerador', 'Andaime / Elevador', 'Ferramenta elétrica', 'Veículo leve'] },
        { id: 'eq_c4', nome: 'Finalidade', tipo: 'texto_longo', obrigatorio: false },
        { id: 'eq_c5', nome: 'Data Necessária', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'eq_c6', nome: 'Período de Uso Previsto', tipo: 'texto', obrigatorio: false },
        { id: 'eq_c7', nome: 'Solicitante', tipo: 'texto', obrigatorio: false },
        { id: 'eq_c8', nome: 'Urgência', tipo: 'lista', obrigatorio: false, opcoes: ['Baixa', 'Média', 'Alta', 'Urgente'], coresOpcoes: CORES_PRIORIDADE },
      ],
    },
    {
      id: 'eq_e2', nome: 'Próprio ou Locação',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['eq_c1', 'eq_c9', 'eq_c12'],
      permiteMoverPara: ['eq_e3', 'eq_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'eq_c9', nome: 'Origem', tipo: 'lista', obrigatorio: true, opcoes: ['Frota própria', 'Locação', 'Transferência de outra obra', 'Compra'], coresOpcoes: { 'Frota própria': COR.azul, 'Locação': COR.amarelo, 'Compra': COR.roxo } },
        { id: 'eq_c10', nome: 'Fornecedor / Locadora', tipo: 'texto', obrigatorio: false },
        { id: 'eq_c11', nome: 'Obra de Origem (transferência)', tipo: 'texto', obrigatorio: false },
        { id: 'eq_c12', nome: 'Custo Mensal / Diária', tipo: 'valor', obrigatorio: false },
        { id: 'eq_c13', nome: 'Contrato de Locação', tipo: 'anexo', obrigatorio: false },
        { id: 'eq_c14', nome: 'Definição aprovada?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'eq_e3', nome: 'Mobilização',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['eq_c1', 'eq_c15', 'eq_c17'],
      permiteMoverPara: ['eq_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'eq_c15', nome: 'Identificação / Placa / Nº de Série', tipo: 'texto', obrigatorio: false },
        { id: 'eq_c16', nome: 'Checklist de Entrada', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Vistoria de recebimento', 'Horímetro/KM inicial anotado', 'Documentação do equipamento', 'Certificado de inspeção', 'Operador habilitado', 'Check list NR-12', 'Seguro vigente'] },
        { id: 'eq_c17', nome: 'Data de Chegada na Obra', tipo: 'data', obrigatorio: false },
        { id: 'eq_c18', nome: 'Horímetro / KM Inicial', tipo: 'numero', obrigatorio: false },
        { id: 'eq_c19', nome: 'Fotos da Vistoria de Entrada', tipo: 'anexo', obrigatorio: false },
        { id: 'eq_c20', nome: 'Liberado para operar?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'eq_e4', nome: 'Em Operação',
      camposVisiveisNoCard: ['eq_c1', 'eq_c2', 'eq_c22'],
      permiteMoverPara: ['eq_e5', 'eq_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'eq_c21', nome: 'Operador Responsável', tipo: 'texto', obrigatorio: false },
        { id: 'eq_c22', nome: 'Horímetro / KM Atual', tipo: 'numero', obrigatorio: false },
        { id: 'eq_c23', nome: 'Próxima Preventiva (horímetro/data)', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'eq_c24', nome: 'Custo Acumulado de Locação', tipo: 'valor', obrigatorio: false },
        { id: 'eq_c25', nome: 'Consumo de Combustível', tipo: 'texto', obrigatorio: false },
        { id: 'eq_c26', nome: 'Precisa de manutenção?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'eq_e5', nome: 'Manutenção',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['eq_c1', 'eq_c27', 'eq_c30'],
      permiteMoverPara: ['eq_e4', 'eq_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'eq_c27', nome: 'Tipo de Manutenção', tipo: 'lista', obrigatorio: true, opcoes: ['Preventiva', 'Corretiva', 'Inspeção obrigatória'], coresOpcoes: { 'Corretiva': COR.vermelho, 'Preventiva': COR.verde } },
        { id: 'eq_c28', nome: 'Descrição do Problema/Serviço', tipo: 'texto_longo', obrigatorio: false },
        { id: 'eq_c29', nome: 'Oficina / Responsável', tipo: 'texto', obrigatorio: false },
        { id: 'eq_c30', nome: 'Custo da Manutenção', tipo: 'valor', obrigatorio: false },
        { id: 'eq_c31', nome: 'Dias Parado', tipo: 'numero', obrigatorio: false },
        { id: 'eq_c32', nome: 'Manutenção concluída?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'eq_e6', nome: 'Desmobilizado',
      camposVisiveisNoCard: ['eq_c1', 'eq_c33', 'eq_c35'],
      permiteCriarCards: false,
      campos: [
        { id: 'eq_c33', nome: 'Data da Devolução / Saída', tipo: 'data', obrigatorio: false },
        { id: 'eq_c34', nome: 'Horímetro / KM Final', tipo: 'numero', obrigatorio: false },
        { id: 'eq_c35', nome: 'Vistoria de saída sem avaria?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'eq_c36', nome: 'Avarias Cobradas', tipo: 'texto_longo', obrigatorio: false },
        { id: 'eq_c37', nome: 'Custo Total do Equipamento na Obra', tipo: 'valor', obrigatorio: false },
        { id: 'eq_c38', nome: 'Termo de Devolução', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'eq_e7', nome: 'Não Atendida',
      camposVisiveisNoCard: ['eq_c1', 'eq_c39'],
      permiteMoverPara: ['eq_e1'],
      permiteCriarCards: false,
      campos: [
        { id: 'eq_c39', nome: 'Motivo', tipo: 'texto_longo', obrigatorio: true },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Definição aprovada inicia a mobilização',
      etapaOrigemId: 'eq_e2',
      condicao: { campoId: 'eq_c14', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'eq_e3',
      etapaDestinoSenaoId: 'eq_e7',
    },
    {
      tipo: 'mover',
      nome: 'Liberado começa a operar',
      etapaOrigemId: 'eq_e3',
      condicao: { campoId: 'eq_c20', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'eq_e4',
    },
    {
      tipo: 'mover',
      nome: 'Pedido de manutenção tira o equipamento de operação',
      etapaOrigemId: 'eq_e4',
      condicao: { campoId: 'eq_c26', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'eq_e5',
    },
    {
      tipo: 'mover',
      nome: 'Manutenção concluída devolve para operação',
      etapaOrigemId: 'eq_e5',
      condicao: { campoId: 'eq_c32', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'eq_e4',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Obra de origem só em transferência',
      etapaOrigemId: 'eq_e2',
      condicao: { campoId: 'eq_c9', operador: 'igual', valor: 'Transferência de outra obra' },
      camposAfetadosIds: ['eq_c11'],
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Avarias quando a vistoria de saída aponta problema',
      etapaOrigemId: 'eq_e6',
      condicao: { campoId: 'eq_c35', operador: 'igual', valor: 'Não' },
      camposAfetadosIds: ['eq_c36'],
    },
  ],
  cards: [
    { id: 'eq_card1', titulo: 'Escavadeira hidráulica 20t', etapaId: 'eq_e4', etiquetas: ['Locado'], valores: { eq_c1: 'Escavadeira hidráulica 20t', eq_c2: 'Alto da Serra', eq_c3: 'Escavadeira', eq_c9: 'Locação', eq_c10: 'Terra Sul Máquinas', eq_c12: 18500, eq_c22: 1840, eq_c24: 37000 } },
    { id: 'eq_card2', titulo: 'Grua ascensional - Torre A', etapaId: 'eq_e4', etiquetas: ['Locado'], valores: { eq_c1: 'Grua ascensional - Torre A', eq_c2: 'Vista Verde - Torre A', eq_c3: 'Grua / Guindaste', eq_c9: 'Locação', eq_c12: 42000, eq_c21: 'Gruista habilitado - Jonas' } },
    { id: 'eq_card3', titulo: 'Caminhão basculante placa AQR-4L21', etapaId: 'eq_e5', etiquetas: ['Frota Própria', 'Parado / Quebrado'], valores: { eq_c1: 'Caminhão basculante placa AQR-4L21', eq_c2: 'Pavimentação Distrito Industrial', eq_c3: 'Caminhão', eq_c9: 'Frota própria', eq_c27: 'Corretiva', eq_c28: 'Vazamento no sistema hidráulico da caçamba.', eq_c30: 7800, eq_c31: 4 } },
    { id: 'eq_card4', titulo: 'Compactador de solo', etapaId: 'eq_e3', valores: { eq_c1: 'Compactador de solo', eq_c2: 'CD Sul', eq_c3: 'Compactador', eq_c9: 'Transferência de outra obra', eq_c11: 'Alto da Serra' } },
    { id: 'eq_card5', titulo: 'Gerador 150 kVA', etapaId: 'eq_e6', etiquetas: ['Locado'], valores: { eq_c1: 'Gerador 150 kVA', eq_c2: 'Centro Clínico Bela Vista', eq_c3: 'Gerador', eq_c9: 'Locação', eq_c35: 'Não', eq_c36: 'Painel frontal amassado. Locadora cobrou R$ 2.400.', eq_c37: 31600 } },
    { id: 'eq_card6', titulo: 'Elevador cremalheira', etapaId: 'eq_e2', valores: { eq_c1: 'Elevador cremalheira', eq_c2: 'Edifício Comercial Prime', eq_c3: 'Andaime / Elevador', eq_c9: 'Locação', eq_c12: 9800 } },
    { id: 'eq_card7', titulo: 'Retroescavadeira - lote 12', etapaId: 'eq_e1', valores: { eq_c1: 'Retroescavadeira - lote 12', eq_c2: 'Alto da Serra', eq_c3: 'Retroescavadeira', eq_c8: 'Alta' } },
  ],
  tour: [
    '🚜 Cada máquina é um card, do pedido à devolução — com custo acumulado visível.',
    '1️⃣ "Solicitação": obra, finalidade e data em que a máquina precisa estar lá.',
    '2️⃣ "Próprio ou Locação": a decisão que mais economiza — tem máquina ociosa em outra obra?',
    '3️⃣ "Mobilização": vistoria de entrada com foto e horímetro inicial anotado.',
    '4️⃣ "Em Operação": horímetro, preventiva programada e custo acumulado de locação.',
    '5️⃣ "Manutenção": dias parado e custo — é o número que justifica trocar de locadora.',
    '📤 "Desmobilizado": vistoria de saída com avaria cobrada e custo total do equipamento na obra.',
  ],
  etapasDicas: [
    { quemFaz: 'Engenheiro / Encarregado', objetivo: 'Pedir com antecedência para não parar frente de serviço.' },
    { quemFaz: 'Suprimentos / Gestão de Frota', objetivo: 'Comparar frota ociosa antes de locar.', automacoes: ['Já configurado: campo de obra de origem aparece só em transferência'] },
    { quemFaz: 'Almoxarife / Segurança', objetivo: 'Vistoriar na chegada — avaria não registrada é avaria sua.' },
    { quemFaz: 'Operador / Encarregado', objetivo: 'Atualizar horímetro e respeitar a preventiva.', automacoes: ['Já configurado: pedido de manutenção tira de operação'] },
    { quemFaz: 'Mecânico / Gestão de Frota', objetivo: 'Registrar custo e dias parado de cada intervenção.' },
    { quemFaz: 'Gestão de Frota', objetivo: 'Fechar o custo real do equipamento naquela obra.' },
    { quemFaz: 'Suprimentos', objetivo: 'Registrar por que a solicitação não foi atendida.' },
  ],
};

const qualidadeFvs: DefaultTemplate = {
  id: 'tpl_qualidade_fvs',
  name: 'Qualidade em Obra (FVS)',
  descricao: 'Ficha de Verificação de Serviço no padrão PBQP-H: serviço inspecionado item a item, não conformidade corrigida, reinspeção e liberação para a etapa seguinte. Serviço só avança quando passa.',
  categoria: 'obras',
  icone: '📋',
  etiquetas: [
    { nome: 'Serviço Crítico', cor: COR.vermelho },
    { nome: 'Reinspeção', cor: COR.amarelo },
    { nome: 'Aprovado', cor: COR.verde },
  ],
  etapas: [
    {
      id: 'fv_e1', nome: 'Serviço a Verificar',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['fv_c1', 'fv_c3', 'fv_c5'],
      permiteMoverPara: ['fv_e2'],
      campos: [
        { id: 'fv_c1', nome: 'Serviço', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'fv_c2', nome: 'Obra', tipo: 'texto', obrigatorio: true },
        { id: 'fv_c3', nome: 'Tipo de Serviço', tipo: 'lista', obrigatorio: true, opcoes: ['Fundação', 'Formas e escoramento', 'Armação', 'Concretagem', 'Alvenaria', 'Instalação elétrica', 'Instalação hidráulica', 'Impermeabilização', 'Contrapiso', 'Revestimento cerâmico', 'Pintura', 'Esquadrias', 'Cobertura'] },
        { id: 'fv_c4', nome: 'Local / Pavimento / Unidade', tipo: 'texto', obrigatorio: true },
        { id: 'fv_c5', nome: 'Executante', tipo: 'texto', obrigatorio: false },
        { id: 'fv_c6', nome: 'Data Prevista da Inspeção', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'fv_c7', nome: 'Procedimento / Norma de Referência', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'fv_e2', nome: 'Inspeção em Campo',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['fv_c1', 'fv_c4', 'fv_c10'],
      permiteMoverPara: ['fv_e3', 'fv_e5'],
      permiteCriarCards: false,
      ordenacaoCards: 'vencimento_proximo',
      campos: [
        { id: 'fv_c8', nome: 'Itens Verificados', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Materiais conforme especificação', 'Alinhamento e prumo', 'Nível e caimento', 'Dimensões conforme projeto', 'Limpeza da base', 'Cura / tempo de secagem', 'Estanqueidade', 'Fixações e ancoragens', 'Acabamento superficial'] },
        { id: 'fv_c9', nome: 'Inspecionado por', tipo: 'texto', obrigatorio: false },
        { id: 'fv_c10', nome: 'Serviço conforme?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'fv_c11', nome: 'Não Conformidades Encontradas', tipo: 'texto_longo', obrigatorio: false },
        { id: 'fv_c12', nome: 'Fotos da Inspeção', tipo: 'anexo', obrigatorio: false },
        { id: 'fv_c13', nome: 'Data da Inspeção', tipo: 'data', obrigatorio: false },
      ],
    },
    {
      id: 'fv_e3', nome: 'Correção',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['fv_c1', 'fv_c14', 'fv_c15'],
      permiteMoverPara: ['fv_e4'],
      permiteCriarCards: false,
      ordenacaoCards: 'vencimento_proximo',
      campos: [
        { id: 'fv_c14', nome: 'Responsável pela Correção', tipo: 'texto', obrigatorio: true },
        { id: 'fv_c15', nome: 'Prazo da Correção', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'fv_c16', nome: 'Ação Executada', tipo: 'texto_longo', obrigatorio: false },
        { id: 'fv_c17', nome: 'Custo do Retrabalho', tipo: 'valor', obrigatorio: false },
        { id: 'fv_c18', nome: 'Correção concluída?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'fv_e4', nome: 'Reinspeção',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['fv_c1', 'fv_c19'],
      permiteMoverPara: ['fv_e5', 'fv_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'fv_c19', nome: 'Aprovado na reinspeção?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'fv_c20', nome: 'Reinspecionado por', tipo: 'texto', obrigatorio: false },
        { id: 'fv_c21', nome: 'Observação da Reinspeção', tipo: 'texto_longo', obrigatorio: false },
        { id: 'fv_c22', nome: 'Fotos da Reinspeção', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'fv_e5', nome: 'Serviço Liberado',
      camposVisiveisNoCard: ['fv_c1', 'fv_c4', 'fv_c23'],
      permiteCriarCards: false,
      campos: [
        { id: 'fv_c23', nome: 'Data da Liberação', tipo: 'data', obrigatorio: false },
        { id: 'fv_c24', nome: 'Libera qual próxima etapa', tipo: 'texto', obrigatorio: false },
        { id: 'fv_c25', nome: 'FVS Assinada', tipo: 'anexo', obrigatorio: false },
        { id: 'fv_c26', nome: 'Teve retrabalho?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Serviço conforme é liberado na hora',
      etapaOrigemId: 'fv_e2',
      condicao: { campoId: 'fv_c10', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'fv_e5',
      etapaDestinoSenaoId: 'fv_e3',
    },
    {
      tipo: 'mover',
      nome: 'Correção feita chama a reinspeção',
      etapaOrigemId: 'fv_e3',
      condicao: { campoId: 'fv_c18', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'fv_e4',
    },
    {
      tipo: 'mover',
      nome: 'Reinspeção aprovada libera o serviço',
      etapaOrigemId: 'fv_e4',
      condicao: { campoId: 'fv_c19', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'fv_e5',
      etapaDestinoSenaoId: 'fv_e3',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Listar não conformidades quando reprovar',
      etapaOrigemId: 'fv_e2',
      condicao: { campoId: 'fv_c10', operador: 'igual', valor: 'Não' },
      camposAfetadosIds: ['fv_c11'],
    },
  ],
  cards: [
    { id: 'fv_card1', titulo: 'Armação de laje - 6º pavimento', etapaId: 'fv_e2', etiquetas: ['Serviço Crítico'], valores: { fv_c1: 'Armação de laje - 6º pavimento', fv_c2: 'Vista Verde - Torre A', fv_c3: 'Armação', fv_c4: '6º pavimento', fv_c5: 'Construtora Pilar', fv_c7: 'NBR 6118' } },
    { id: 'fv_card2', titulo: 'Impermeabilização box - apto 302', etapaId: 'fv_e3', etiquetas: ['Reinspeção'], valores: { fv_c1: 'Impermeabilização box - apto 302', fv_c2: 'Vista Verde - Torre A', fv_c3: 'Impermeabilização', fv_c4: 'Apto 302', fv_c10: 'Não', fv_c11: 'Falta de recobrimento na saída do ralo e ausência de teste de estanqueidade.', fv_c14: 'Impermax Engenharia', fv_c15: '2026-08-19' } },
    { id: 'fv_card3', titulo: 'Contrapiso - área comum térreo', etapaId: 'fv_e5', etiquetas: ['Aprovado'], valores: { fv_c1: 'Contrapiso - área comum térreo', fv_c2: 'Edifício Comercial Prime', fv_c3: 'Contrapiso', fv_c4: 'Térreo', fv_c26: 'Não' } },
    { id: 'fv_card4', titulo: 'Concretagem de pilares - 3º pav.', etapaId: 'fv_e4', etiquetas: ['Serviço Crítico'], valores: { fv_c1: 'Concretagem de pilares - 3º pav.', fv_c2: 'Alto da Serra', fv_c3: 'Concretagem', fv_c4: '3º pavimento', fv_c10: 'Não', fv_c18: 'Sim' } },
    { id: 'fv_card5', titulo: 'Alvenaria - casas 12 a 20', etapaId: 'fv_e1', valores: { fv_c1: 'Alvenaria - casas 12 a 20', fv_c2: 'Condomínio Alto da Serra', fv_c3: 'Alvenaria', fv_c4: 'Casas 12-20', fv_c5: 'Empreiteira Nova Era' } },
    { id: 'fv_card6', titulo: 'Instalação elétrica - galpão', etapaId: 'fv_e5', etiquetas: ['Aprovado'], valores: { fv_c1: 'Instalação elétrica - galpão', fv_c2: 'Galpão Logístico CD Sul', fv_c3: 'Instalação elétrica', fv_c4: 'Área principal', fv_c24: 'Liberado para forro e acabamento', fv_c26: 'Sim' } },
  ],
  tour: [
    '📋 FVS do PBQP-H virou card: serviço só avança quando passa na inspeção.',
    '1️⃣ "Serviço a Verificar": local exato e norma de referência.',
    '2️⃣ "Inspeção em Campo": checklist de itens e foto. Conforme? o card já libera sozinho.',
    '3️⃣ "Correção": responsável, prazo e o custo do retrabalho registrado.',
    '4️⃣ "Reinspeção": reprovou de novo? volta para correção.',
    '✅ "Serviço Liberado": FVS assinada e qual próxima etapa foi destravada.',
    '📊 Filtre por executante para ver quem gera mais retrabalho — dado de ouro na renovação de contrato.',
  ],
  etapasDicas: [
    { quemFaz: 'Engenheiro / Estagiário de Qualidade', objetivo: 'Programar a inspeção antes do serviço ser coberto.' },
    { quemFaz: 'Engenheiro / Técnico de Qualidade', objetivo: 'Inspecionar item a item, com foto.', automacoes: ['Já configurado: conforme libera na hora, não conforme abre correção'] },
    { quemFaz: 'Empreiteiro / Encarregado', objetivo: 'Corrigir no prazo — o custo do retrabalho fica registrado.' },
    { quemFaz: 'Qualidade', objetivo: 'Reinspecionar antes de liberar a etapa seguinte.' },
    { quemFaz: 'Engenheiro da Obra', objetivo: 'Liberar formalmente para a próxima etapa.', conexoes: ['Ligue à "Medição de Empreiteiro" — serviço reprovado não deveria ser medido'] },
  ],
};

const meioAmbienteResiduos: DefaultTemplate = {
  id: 'tpl_meio_ambiente_residuos',
  name: 'Meio Ambiente e Resíduos',
  descricao: 'Gestão de resíduos da construção (PGRCC) e conformidade ambiental: segregação por classe, transporte com MTR, destinação com certificado e tratamento de não conformidade ambiental.',
  categoria: 'obras',
  icone: '♻️',
  etiquetas: [
    { nome: 'Classe Perigosa', cor: COR.vermelho },
    { nome: 'Reciclável', cor: COR.verde },
    { nome: 'Autuação', cor: COR.amarelo },
  ],
  etapas: [
    {
      id: 'ma_e1', nome: 'Registro / Programação',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['ma_c1', 'ma_c3', 'ma_c5'],
      permiteMoverPara: ['ma_e2', 'ma_e6'],
      campos: [
        { id: 'ma_c1', nome: 'Identificação', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'ma_c2', nome: 'Obra', tipo: 'texto', obrigatorio: true },
        { id: 'ma_c3', nome: 'Classe do Resíduo', tipo: 'lista', obrigatorio: true, opcoes: ['Classe A - reutilizável (concreto, alvenaria)', 'Classe B - reciclável (madeira, plástico, metal)', 'Classe C - sem tecnologia (gesso)', 'Classe D - perigoso (tinta, solvente, amianto)'], coresOpcoes: { 'Classe A - reutilizável (concreto, alvenaria)': COR.cinza, 'Classe B - reciclável (madeira, plástico, metal)': COR.verde, 'Classe D - perigoso (tinta, solvente, amianto)': COR.vermelho } },
        { id: 'ma_c4', nome: 'Descrição do Material', tipo: 'texto_longo', obrigatorio: false },
        { id: 'ma_c5', nome: 'Volume Estimado (m³)', tipo: 'numero', obrigatorio: false },
        { id: 'ma_c6', nome: 'Data Prevista da Retirada', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'ma_c7', nome: 'Origem na Obra', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'ma_e2', nome: 'Segregação e Acondicionamento',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['ma_c1', 'ma_c3', 'ma_c9'],
      permiteMoverPara: ['ma_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'ma_c8', nome: 'Acondicionamento', tipo: 'lista', obrigatorio: false, opcoes: ['Caçamba estacionária', 'Baia de segregação', 'Bombona identificada', 'Big bag', 'Área coberta impermeável'] },
        { id: 'ma_c9', nome: 'Segregação conforme PGRCC?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'ma_c10', nome: 'Fotos do Acondicionamento', tipo: 'anexo', obrigatorio: false },
        { id: 'ma_c11', nome: 'Observação', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'ma_e3', nome: 'Transporte (MTR)',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['ma_c1', 'ma_c13', 'ma_c12'],
      permiteMoverPara: ['ma_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'ma_c12', nome: 'Transportadora', tipo: 'texto', obrigatorio: true },
        { id: 'ma_c13', nome: 'Nº do MTR', tipo: 'texto', obrigatorio: false },
        { id: 'ma_c14', nome: 'Licença da Transportadora', tipo: 'anexo', obrigatorio: false },
        { id: 'ma_c15', nome: 'Data da Coleta', tipo: 'data', obrigatorio: false },
        { id: 'ma_c16', nome: 'Volume Real Retirado (m³)', tipo: 'numero', obrigatorio: false },
        { id: 'ma_c17', nome: 'Custo do Transporte', tipo: 'valor', obrigatorio: false },
        { id: 'ma_c18', nome: 'MTR emitido?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'ma_e4', nome: 'Destinação Final',
      tempoMaximoHoras: 168,
      camposVisiveisNoCard: ['ma_c1', 'ma_c19', 'ma_c22'],
      permiteMoverPara: ['ma_e5', 'ma_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'ma_c19', nome: 'Destinador', tipo: 'texto', obrigatorio: true },
        { id: 'ma_c20', nome: 'Tipo de Destinação', tipo: 'lista', obrigatorio: false, opcoes: ['Aterro licenciado', 'Reciclagem', 'Reutilização na obra', 'Coprocessamento', 'Tratamento de perigoso', 'Logística reversa'] },
        { id: 'ma_c21', nome: 'Licença Ambiental do Destinador', tipo: 'anexo', obrigatorio: false },
        { id: 'ma_c22', nome: 'CDF recebido?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'ma_c23', nome: 'Certificado de Destinação (CDF)', tipo: 'anexo', obrigatorio: false },
        { id: 'ma_c24', nome: 'Custo da Destinação', tipo: 'valor', obrigatorio: false },
      ],
    },
    {
      id: 'ma_e5', nome: 'Comprovado',
      camposVisiveisNoCard: ['ma_c1', 'ma_c3', 'ma_c25'],
      permiteCriarCards: false,
      campos: [
        { id: 'ma_c25', nome: 'Data do Encerramento', tipo: 'data', obrigatorio: false },
        { id: 'ma_c26', nome: 'Custo Total', tipo: 'valor', obrigatorio: false },
        { id: 'ma_c27', nome: 'Observação Final', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'ma_e6', nome: 'Não Conformidade Ambiental',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['ma_c1', 'ma_c28', 'ma_c31'],
      permiteMoverPara: ['ma_e2', 'ma_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'ma_c28', nome: 'Tipo de Ocorrência', tipo: 'lista', obrigatorio: true, opcoes: ['Descarte irregular', 'Segregação incorreta', 'Vazamento / contaminação', 'MTR ou CDF ausente', 'Notificação de órgão', 'Autuação / multa', 'Supressão vegetal irregular'], coresOpcoes: { 'Autuação / multa': COR.vermelho, 'Vazamento / contaminação': COR.vermelho } },
        { id: 'ma_c29', nome: 'Descrição', tipo: 'texto_longo', obrigatorio: true },
        { id: 'ma_c30', nome: 'Órgão Notificante', tipo: 'texto', obrigatorio: false },
        { id: 'ma_c31', nome: 'Prazo para Regularizar', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'ma_c32', nome: 'Valor da Multa', tipo: 'valor', obrigatorio: false },
        { id: 'ma_c33', nome: 'Ação Corretiva', tipo: 'texto_longo', obrigatorio: false },
        { id: 'ma_c34', nome: 'Regularizado?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Segregação conforme libera o transporte',
      etapaOrigemId: 'ma_e2',
      condicao: { campoId: 'ma_c9', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'ma_e3',
    },
    {
      tipo: 'mover',
      nome: 'MTR emitido segue para destinação',
      etapaOrigemId: 'ma_e3',
      condicao: { campoId: 'ma_c18', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'ma_e4',
    },
    {
      tipo: 'mover',
      nome: 'CDF recebido comprova a destinação',
      etapaOrigemId: 'ma_e4',
      condicao: { campoId: 'ma_c22', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'ma_e5',
      etapaDestinoSenaoId: 'ma_e6',
    },
    {
      tipo: 'mover',
      nome: 'Não conformidade regularizada encerra',
      etapaOrigemId: 'ma_e6',
      condicao: { campoId: 'ma_c34', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'ma_e5',
    },
  ],
  cards: [
    { id: 'ma_card1', titulo: 'Entulho de demolição - bloco B', etapaId: 'ma_e3', valores: { ma_c1: 'Entulho de demolição - bloco B', ma_c2: 'Reforma da Loja Matriz', ma_c3: 'Classe A - reutilizável (concreto, alvenaria)', ma_c5: 24, ma_c12: 'Caçambas Rápidas', ma_c13: 'MTR-2026-88421' } },
    { id: 'ma_card2', titulo: 'Latas de tinta e solvente', etapaId: 'ma_e4', etiquetas: ['Classe Perigosa'], valores: { ma_c1: 'Latas de tinta e solvente', ma_c2: 'Edifício Comercial Prime', ma_c3: 'Classe D - perigoso (tinta, solvente, amianto)', ma_c5: 2, ma_c19: 'EcoTratamento Ambiental', ma_c20: 'Tratamento de perigoso', ma_c22: 'Não' } },
    { id: 'ma_card3', titulo: 'Sobras de madeira de forma', etapaId: 'ma_e5', etiquetas: ['Reciclável'], valores: { ma_c1: 'Sobras de madeira de forma', ma_c2: 'Vista Verde - Torre A', ma_c3: 'Classe B - reciclável (madeira, plástico, metal)', ma_c5: 18, ma_c20: 'Reciclagem', ma_c26: 3400 } },
    { id: 'ma_card4', titulo: 'Placas de gesso acartonado', etapaId: 'ma_e2', valores: { ma_c1: 'Placas de gesso acartonado', ma_c2: 'Centro Clínico Bela Vista', ma_c3: 'Classe C - sem tecnologia (gesso)', ma_c5: 6, ma_c9: 'Sim' } },
    { id: 'ma_card5', titulo: 'Descarte irregular na via lateral', etapaId: 'ma_e6', etiquetas: ['Autuação'], valores: { ma_c1: 'Descarte irregular na via lateral', ma_c2: 'Condomínio Alto da Serra', ma_c3: 'Classe A - reutilizável (concreto, alvenaria)', ma_c28: 'Autuação / multa', ma_c29: 'Fiscalização flagrou caçamba descarregando fora do aterro licenciado.', ma_c30: 'Secretaria de Meio Ambiente', ma_c32: 18000 } },
    { id: 'ma_card6', titulo: 'Sucata metálica da estrutura', etapaId: 'ma_e1', etiquetas: ['Reciclável'], valores: { ma_c1: 'Sucata metálica da estrutura', ma_c2: 'Galpão Logístico CD Sul', ma_c3: 'Classe B - reciclável (madeira, plástico, metal)', ma_c5: 9 } },
  ],
  tour: [
    '♻️ PGRCC funcionando: do resíduo gerado ao certificado de destinação arquivado.',
    '1️⃣ "Registro": classe do resíduo definida logo na origem — é o que dita todo o resto.',
    '2️⃣ "Segregação": acondicionamento correto com foto.',
    '3️⃣ "Transporte": MTR e licença da transportadora no card.',
    '4️⃣ "Destinação Final": sem CDF o card cai em não conformidade automaticamente.',
    '✅ "Comprovado": custo total do resíduo por obra.',
    '⚠️ "Não Conformidade Ambiental": autuação, multa e prazo de regularização controlados.',
  ],
  etapasDicas: [
    { quemFaz: 'Encarregado / Técnico Ambiental', objetivo: 'Classificar certo — classe D exige tratamento e documentação própria.' },
    { quemFaz: 'Equipe de Obra', objetivo: 'Segregar na origem; misturou, vira classe D inteira.', automacoes: ['Já configurado: conforme libera o transporte'] },
    { quemFaz: 'Administrativo da Obra', objetivo: 'Não liberar caçamba sem MTR emitido.' },
    { quemFaz: 'Técnico Ambiental', objetivo: 'Cobrar o CDF do destinador — é a prova legal da destinação.', automacoes: ['Já configurado: sem CDF vira não conformidade'] },
    { quemFaz: 'Técnico Ambiental', objetivo: 'Consolidar custo e volume por obra para o relatório do PGRCC.' },
    { quemFaz: 'Meio Ambiente / Jurídico', objetivo: 'Tratar autuação dentro do prazo do órgão.' },
  ],
};

export const TEMPLATES_OBRAS_GESTAO: DefaultTemplate[] = [
  licitacaoObra,
  medicaoContrato,
  aditivosPleitos,
  coordenacaoProjetos,
  equipamentosFrota,
  qualidadeFvs,
  meioAmbienteResiduos,
];
